export const initialState = {
  loadingStatus: {
    caseListLoading: false,
  },
  error: '',
  caseList: [],
};
